import * as Sentry from '@sentry/browser';

const envMetaEl : HTMLMetaElement | null = document.querySelector("meta[name='environment']");
const dsnMetaEl : HTMLMetaElement | null = document.querySelector("meta[name='sentry']");
const environment = envMetaEl?.content || "unknown";
const dsn = dsnMetaEl?.content;

if (Sentry.isInitialized()) {
  console.log("Skipping Sentry configuration, already initialized");
} else if (dsn) {
  const release = import.meta.env.VITE_APP_VERSION ? `javascript@${import.meta.env.VITE_APP_VERSION}` : undefined;

  Sentry.init({
    dsn: dsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: environment,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      // https://github.com/getsentry/sentry/issues/5267
      'SecurityError: Blocked a frame with origin "https://www.delivereasy.co.nz" from accessing',
      'Cannot read properties of null (reading \'startGetFields\')',
    ],
    tracesSampleRate: 0.01,
    release: release,
    // Force enable the ip reporting
    // The SDK usually only enables this if you have enabled the default PII collection,
    // but they explicitly don't override values set here so this should be stable-ish.
    _metadata: { sdk: { settings: { infer_ip: "auto" } } }
  });

  if (window.sentryExtraUserInfo != undefined) {
    Sentry.setUser(window.sentryExtraUserInfo);
  }
} else {
  console.warn("Skipping Sentry configuration because no DSN was supplied");
}
